// MyWorker.js

// @args: You can pass your worker parameters on initialization
var storedCanvas;

module.exports = function(args) {

  var onmessage = function(e){ // eslint-disable-line no-unused-vars
    // Write your code here...
    // console.log("WEBWORKER START", e);

    const roundValue = (value, decimals) => {
      if(value === undefined) return value;
      if(value === null) return value;
      if(isNaN(value)) return value;
      if(value.toFixed === undefined) return value;
      value = parseFloat(value.toFixed(decimals + 1));
      var retval = Number(Math.round(value+'e'+decimals)+'e-'+decimals);
      return retval;
    }

    const colorList = ['#57A3E5','#5353E4','#9950E2','#E151E1','#E05299','#DF5353','#DE9954','#DDDD55','#99DD55','#56DC56','#57DB99','#58DADA']//['#e6194b','#3cb44b','#ffe119','#0082c8','#f58231','#911eb4','#46f0f0','#f032e6','#d2f53c','#fabebe','#008080','#e6beff','#aa6e28','#fffac8','#800000','#aaffc3','#808000','#ffd8b1','#000080','#808080'];

    const colors = {
      light: {
        bg: '#fff',
        lines: '#222',
        lineErrors: '#D24128',
        grid: '#ccc',
        rulerBG: '#fff',
        rulerEdge: '#155589',
        rulerTicks: '#155589',
        stroke_width: 1
      },
      dark: {
        bg: '#070809',
        lines: '#fff',
        lineErrors: '#D24128',
        grid: '#666',
        rulerBG: '#070809',
        rulerEdge: '#5BA5E6',
        rulerTicks: '#5BA5E6',
        stroke_width: 1
      }
    }

    const render = (canvas, input_pattern, settings) => {
      
      var default_settings = {
        width: 640,
        height: 480,
        origin: {x: -1, y: 1},
        gui: true,
        colorLines: true,
        lights: true,
        showErrors: false,
        thumbnail: false,
        scaleValue: 1,
        fixedScale: false
      }

      // extend default settings
      settings = Object.assign({}, default_settings, settings);
      let pattern = JSON.parse(JSON.stringify(input_pattern));



      // settings.origin = {x: 0, y: 0};
      // console.log('start render', settings);
      
      // set color palette 
      var colorConfig = settings.lights ? colors.light : colors.dark;

      if(settings.color){
        if(settings.color.lines){
          colorConfig.lines = settings.color.lines;
        }
        if(settings.color.bg){
          colorConfig.bg = settings.color.bg;
        }
        if(settings.color.stroke_width){
          colorConfig.stroke_width = settings.color.stroke_width;
        }
      }


      // console.log(settings, colorConfig);

      // short hand these common variables
      var w = settings.width;
      var h = settings.height;

      var rows = pattern.rows;

      if(!w) w = 640;
      if(!h) h = 480;

      // set dimensions
      // canvas.style = { width: w, height: h }
      if(canvas.setAttribute){
        canvas.setAttribute('width', w);
        canvas.setAttribute('height', h);
      } else {
        canvas.style = { width: w, height: h };
        canvas.width = w;
        canvas.height = h;
      }

      // get context and clear it
      var context = canvas.getContext("2d");
      context.setTransform(1, 0, 0, 1, 0, 0);
      // context.clearRect(0, 0, w, h);
      context.fillStyle = colorConfig.bg;
      
      context.fillRect(0, 0, w, h);


      //////////////////////////////////////////////////////
      //////////////////////////////////////////////////////
      /// SCALE
      //////////////////////////////////////////////////////
      //////////////////////////////////////////////////////

      var scale = 1;

      // if(pattern.type === 'DRAFTING' && pattern.format !== 'AUTOCAD'){ // anti-pattern due to some patterns not having a format
      //   // Set DPI for INCH and MM
      //   if(pattern.units === 'INCH'){
      //     scale = 96;
      //   } else if (pattern.units === 'MM'){
      //     scale = 96 / 25.4;
      //   }

      //   if(settings.thumbnail) scale /= 1.5;
      // } else {
        // Auto scale for model patterns or thumbnails
        var max = 1;
        var total = 0;
        var count = 0;
        for(var i = 0; i < rows.length; i++){
          for(var j = 0; j < rows[i].cells.length; j++){
            if(j === 0 || j === 3 || j === 4 || j > 5) continue;
            if(Math.abs(rows[i].cells[j] > max)) max = Math.abs(rows[i].cells[j]);
            total += Math.abs(rows[i].cells[j]);
            count++;
          }
        }

        if(pattern.mode === 'drawing'){
          if(pattern.width > max) max = pattern.width;
          if(pattern.height > max) max = pattern.height;
          // max /= 2;
        }
        
        scale = h / (max) / 5;
      // }

      scale *= settings.scaleValue;

      if(settings.fixedScale){
        scale = settings.fixedScale;
      }

      // console.log('scale', scale);


      //////////////////////////////////////////////////////
      //////////////////////////////////////////////////////
      /// GRID LINES
      //////////////////////////////////////////////////////
      //////////////////////////////////////////////////////


      // gridMargin amount
      var gridMargin = 50;
      var gridMarginX = w / 2;
      var gridMarginY = h / 2;

      var bl_x = -w / 2;
      var bl_y = h / 2;
      var br_x =  w / 2;
      var br_y = h / 2;

      var tl_x = -w / 2;
      var tl_y = -h / 2;
      var tr_x =  w / 2;
      var tr_y = -h / 2;


      if(settings.origin){
        if(settings.origin.x === 1){
          gridMarginX = w - gridMargin;
          br_x = gridMargin;
          bl_x = -(w - gridMargin);
          tr_x = gridMargin;
          tl_x = -(w - gridMargin);
        }
        if(settings.origin.x === -1){
          gridMarginX = gridMargin;
          bl_x = -gridMargin;
          br_x = (w - gridMargin);
          tl_x = -gridMargin;
          tr_x = (w - gridMargin);
        }
        if(settings.origin.y === 1){
          gridMarginY = h - gridMargin;
          tr_y = (h - gridMargin);
          tl_y = (h - gridMargin);
          br_y = -gridMargin;
          bl_y = -gridMargin;
        }
        if(settings.origin.y === -1){
          gridMarginY = gridMargin;
          tr_y = gridMargin;
          tl_y = gridMargin;
          br_y = -(h - gridMargin);
          bl_y = -(h - gridMargin);
        }
      } 


      context.fillStyle = colorConfig.bg;
      context.beginPath();
      context.rect(0,0,w,h);
      // context.rect(tl_x, -tl_y, tr_x - tl_x, tl_y - bl_y);
      context.fill();


      bl_x /= scale;
      bl_y /= scale;
      br_x /= scale;
      br_y /= scale;

      tl_x /= scale;
      tl_y /= scale;
      tr_x /= scale;
      tr_y /= scale;

      // console.log('WH', w / scale, h / scale);

      // Set 0,0
      context.translate(gridMarginX, gridMarginY);

      // Draw grid lines
      if(settings.gui && !settings.thumbnail){
        context.lineWidth = 1;
        context.strokeStyle = colorConfig.grid;
        context.setLineDash([5,5]);

        // vertical gridline
        context.beginPath();
        context.moveTo(0, -h);
        context.lineTo(0, h);
        context.stroke();

        // horizontal grid line
        context.beginPath();
        context.moveTo(-w, 0);
        context.lineTo(w, 0);
        context.stroke();


        if(pattern.mode === 'drawing'){
          // console.log(pattern);

          for(var tgw = 1; tgw < w / (pattern.width * scale); tgw++){
            // vertical gridline
            context.beginPath();
            context.moveTo(pattern.width * scale * tgw, -h);
            context.lineTo(pattern.width * scale * tgw, h);
            context.stroke();

            // vertical gridline
            context.beginPath();
            context.moveTo(pattern.width * scale * (-tgw), -h);
            context.lineTo(pattern.width * scale * (-tgw), h);
            context.stroke();
          }


          for(var tgh = 1; tgh < h / (pattern.height * scale); tgh++){
         
            // horizontal grid line
            context.beginPath();
            context.moveTo(-w, pattern.height * scale * tgh);
            context.lineTo(w, pattern.height * scale * tgh);
            context.stroke();

            // horizontal grid line
            context.beginPath();
            context.moveTo(-w, pattern.height * scale * (-tgh));
            context.lineTo(w, pattern.height * scale * (-tgh));
            context.stroke();
          }
        }
      }

      //////////////////////////////////////////////////////
      //////////////////////////////////////////////////////
      /// DRAW ROW
      //////////////////////////////////////////////////////
      //////////////////////////////////////////////////////

      if(pattern.decimal_places === undefined) pattern.decimal_places = 8;

      function drawRow(r, perpOffset, factor, stretch, noDash){
        // console.log(r);
        r = JSON.parse(JSON.stringify(r));
          
        // console.log('before rounding', r);
        for(var i in r){
          r[i] = roundValue(parseFloat(r[i]), pattern.decimal_places);
        }
        // console.log('after rounding', r);

        var dasharray = r.splice(5, r.length);
        // console.log(dasharray);

        // autocad dash sequences can only be 6 items long
        if(pattern.format === 'AUTOCAD'){
          dasharray = dasharray.splice(0, 6);
        }

        var dasharraySum = 0;
        var dasharrayHasValue = false;
        var invertedDashArray = false;

        for(var i = 0; i < dasharray.length; i++){
          if(isNaN(dasharray[i]) || dasharray[i] === null){
            dasharray.splice(i, 1);
            i--;
          }
          if(i === 0 && dasharray[i] < 0) invertedDashArray = true;
          if(dasharray[i] < 0) dasharray[i] *= -1;
          if(dasharray[i] > 0) dasharrayHasValue = true;
          if(dasharray[i] === 0) dasharray[i] = 1 / scale;
        }

        for(var i in dasharray){
          dasharraySum += dasharray[i];
        }

        if(!perpOffset) perpOffset = 0;

        var currentX = r[1];
        var currentY = r[2];
        
        var a = r[0] * Math.PI / 180;
        var aP = (r[0] - 90) * Math.PI / 180;

        currentX += perpOffset * (Math.cos(aP) * r[4]);
        currentY += perpOffset * (Math.sin(aP) * r[4]);
        var offset_only_x = currentX;
        var offset_only_y = currentY;

        currentX -= perpOffset * (Math.cos(a) * r[3]);
        currentY -= perpOffset * (Math.sin(a) * r[3]);

        var x1 = currentX + 0;
        var y1 = currentY + 0;

        var t = stretch ? 1000000 : dasharraySum; // dasharraySum || 1; 

        var dif_x = Math.cos(a + Math.PI * factor) * t;
        var dif_y = Math.sin(a + Math.PI * factor) * t;

        var x2 = x1 + dif_x;
        var y2 = y1 + dif_y;

        if(stretch || !dasharrayHasValue){

          var intersect_bottom = checkLineIntersection(x1,y1,x2,y2, bl_x,bl_y, br_x,br_y);
          var intersect_top = checkLineIntersection(x1,y1,x2,y2, tl_x,tl_y, tr_x,tr_y);

          var intersect_left = checkLineIntersection(x1,y1,x2,y2, bl_x,bl_y, tl_x,tl_y);
          var intersect_right = checkLineIntersection(x1,y1,x2,y2, br_x,br_y, tr_x,tr_y);
          
          var intersections = [intersect_bottom, intersect_top, intersect_left, intersect_right];

          // KEEP FOR DEBUG
          // for(var i in intersections){
          //   var int = intersections[i];
          //   context.fillStyle = 'rgba(0,0,255,.5)';
          //   context.beginPath();
          //   context.arc(int.x,-int.y, 10/scale, 0,2*Math.PI);
          //   context.fill();
          // }

          // var foundEnd = false;
          for(var i = 0; i < intersections.length; i++){
            if(!intersections[i].onLine2){
              intersections.splice(i, 1);
              i--;
            }
          }

          if(intersections.length < 2) return;

          // dedupe intersections for lines that exactly hit corners
          for(let i = 0; i < intersections.length; i++){
            for(let j = i + 1; j < intersections.length; j++){
              if(intersections[i].x === intersections[j].x && intersections[i].y === intersections[j].y){
                intersections.splice(i, 1);
                i--;
              }
            }
          }

          if(intersections.length < 2) return;

          var a0 = Math.atan2(intersections[0].y - y1, intersections[0].x - x1) / Math.PI / 2 * 360;
          var a1 = Math.atan2(intersections[1].y - y1, intersections[1].x - x1) / Math.PI / 2 * 360;

          var comp = r[0];
          if(comp > 360) comp -= 360;
          if(comp < 0) comp += 360;
          if(factor === 1){ 
            comp += 180;
            if(comp > 360) comp -= 360;
            if(comp < 0) comp += 360;
          }

          if(a0 > 360) a0 -= 360;
          if(a0 < 0) a0 += 360;
          if(a1 > 360) a1 -= 360;
          if(a1 < 0) a1 += 360;

          a0 = Math.round(a0);
          a1 = Math.round(a1);
          comp = Math.round(comp);
          
          // wrong way completely
          if(comp !== a0 && a0 === a1) return;
          
          if(comp === a0 && comp === a1){
            intersections.sort(function(a, b){
              if(distance(a.x,a.y,x1,y1) > distance(b.x,b.y,x1,y1)){
                return -1;
              } 
              return 1;
            })
            x2 = intersections[0].x;
            y2 = intersections[0].y;
            
          } else if(comp === a0){
            x2 = intersections[0].x;
            y2 = intersections[0].y;
            
          } else if(comp === a1){
            x2 = intersections[1].x;
            y2 = intersections[1].y;
            
          } else if(comp !== a0 && comp !== a1){
            return;
          }
        }
        
        context.beginPath();
        context.moveTo(x1, -y1);
        
        if(!dasharrayHasValue || (noDash && perpOffset === 0)){
          context.lineDashOffset = 0;
          context.setLineDash([]);
        } else {

          context.lineDashOffset = 0;
          context.setLineDash(dasharray);  

          if(invertedDashArray && factor === 0){
            context.lineDashOffset = -dasharray[0];
            dasharray.splice(dasharray.length, 0, dasharray.splice(0, 1)[0]);
            context.setLineDash(dasharray);
          } else if(invertedDashArray && factor === 1){
            context.lineDashOffset = 0;
            var backwardsDashArray = dasharray.reverse();
            context.setLineDash(backwardsDashArray);
          } else if(factor === 1 && !invertedDashArray){

            context.lineDashOffset = -dasharray[dasharray.length - 1];
            var backwardsDashArray = dasharray.reverse();
            backwardsDashArray.splice(backwardsDashArray.length, 0, backwardsDashArray.splice(0, 1)[0]);
            context.setLineDash(backwardsDashArray);
          }
        }

        context.lineTo(x2, -y2);
        context.lineCap = "round";
        context.stroke();


        
        return {
          x1: x1, 
          y1: y1, 
          x2: x2, 
          y2: y2
        };
      }

      //////////////////////////////////////////////////////
      //////////////////////////////////////////////////////
      /// ITERATE ROWS
      //////////////////////////////////////////////////////
      //////////////////////////////////////////////////////

      // Use the scale
      context.scale(scale, scale);
      context.strokeStyle = colorConfig.lines;
      context.lineWidth = colorConfig.stroke_width / scale;


      // context.beginPath();
      // context.arc(tl_x,-tl_y, 10/scale, 0,2*Math.PI);
      // context.fill();
      // context.beginPath();
      // context.arc(tr_x,-tr_y, 10/scale, 0,2*Math.PI);
      // context.fill();

      // // context.fillStyle = 'rgba(0,255,0,1)';
      // context.beginPath();
      // context.arc(bl_x,-bl_y, 10/scale, 0,2*Math.PI);
      // context.fill();
      // context.beginPath();
      // context.arc(br_x,-br_y, 10/scale, 0,2*Math.PI);
      // context.fill();

      // console.log('TL', tl_x, tl_y);
      // console.log('TR', tr_x, tr_y);
      // console.log('BL', bl_x, bl_y);
      // console.log('BR', br_x, br_y);
      

      for(var i = 0; i < rows.length; i++){
        if(rows[i].invisible) continue;
        if(rows[i].bold){
          context.lineWidth = (colorConfig.stroke_width * 3) / scale;
        } else {
          context.lineWidth = colorConfig.stroke_width / scale;
        }
        context.strokeStyle = colorConfig.lines;
        if(settings.showErrors){
          if(rows[i].errors){
            if(rows[i].errors.length > 0){
              context.strokeStyle = colorConfig.lineErrors;
            }
          }
        }

        // Handle dots
        for(var ii = 5; ii < rows[i].cells.length - 1; ii += 2){
          if(rows[i].cells[ii] !== "" && rows[i].cells[ii + 1] !== "" && rows[i].cells[ii] !== null && rows[i].cells[ii + 1] !== null){
            if(rows[i].cells[ii] == 0 && rows[i].cells[ii + 1] !== 0){
              let min = .0001;
              rows[i].cells[ii] = min;
              rows[i].cells[ii+1] -= min;
            }
          }
        }
        
        if(rows[i].cells[4] != 0){
          var drawIt = true;
          var lastCoordinates = {};
          var index = 0;
          var drawMinimum = 50;
          var drawMaximum = 10000; // this variable prevents shit from going crazy and crashing the site. Might need to be adjusted


          while( (drawIt || index < drawMinimum) && (index < drawMaximum) ){
            drawIt = drawRow(rows[i].cells, index, 0, true);
            index++;
          }
          
          
          drawIt = true;
          lastCoordinates = {};
          index = 0;
          while( (drawIt || index < drawMinimum) && (index < drawMaximum) ){
            drawIt = drawRow(rows[i].cells, index, 1, true);
            index++;
          }
          
          
          drawIt = true;
          lastCoordinates = {};
          index = -1;
          while( (drawIt || index > -drawMinimum) && (index > -drawMaximum) ){
            drawIt = drawRow(rows[i].cells, index, 0, true);
            index--;
          }
          
          
          drawIt = true;
          lastCoordinates = {};
          index = -1;
          while( (drawIt || index > -drawMinimum) && (index > -drawMaximum) ){
            drawIt = drawRow(rows[i].cells, index, 1, true);
            index--;
          }
          

        } else {
          drawRow(rows[i].cells, 0, 0, true);
          drawRow(rows[i].cells, 0, 1, true);  
        }
      }

      //////////////////////////////////////////////////////
      //////////////////////////////////////////////////////
      /// COLOR ROWS
      //////////////////////////////////////////////////////
      //////////////////////////////////////////////////////

      if(!settings.thumbnail && settings.colorLines){
        
        for(i = 0; i < rows.length; i++){
          if(rows[i].invisible) continue;
          if(rows[i].greyscale) continue;

          // context.strokeStyle = '#999';
          // context.lineWidth = 2 / scale;
          // drawRow(rows[i].cells, 0, 0, false, true);
          // drawRow(rows[i].cells, 1, 0, false, true);
          // if(!rows[i].cells[5] && !rows[i].cells[6]){
          //   drawRow(rows[i].cells, 0, 1, false, true);
          //   drawRow(rows[i].cells, 1, 1, false, true);
          // }

          context.strokeStyle = colorList[(rows[i].original_index * 3) % 11];
          if(rows[i].bold){
            context.lineWidth = (colorConfig.stroke_width * 4) / scale;
          } else {
            context.lineWidth = (colorConfig.stroke_width * 2) / scale;
          }

          var stretch = false;
          if(!rows[i].cells[5] && !rows[i].cells[6]){
            stretch = true;
          }
          
          drawRow(rows[i].cells, 0, 0, stretch);
          if(!rows[i].cells[5] && !rows[i].cells[6]){
            drawRow(rows[i].cells, 0, 1, stretch);
          }
        }
      }

      //////////////////////////////////////////////////////
      //////////////////////////////////////////////////////
      /// RULERS
      //////////////////////////////////////////////////////
      //////////////////////////////////////////////////////

      if(settings.zoomSlider){
        context.setTransform(1, 0, 0, 1, 0, 0);
        // context.fillStyle = colorConfig.bg;
        // context.fillRect(0, h - 25, w, 25);
      }
      
      if(!settings.thumbnail && settings.rulers){
        var rulerWidth = 10;
        context.setTransform(1, 0, 0, 1, 0, 0);
        context.fillStyle = colorConfig.bg;
        context.fillRect(0, 0, w, rulerWidth);
        context.fillRect(0, 0, rulerWidth, h);

        context.strokeStyle = colorConfig.rulerTicks;
        context.setLineDash([]);
        context.lineWidth = 1;

        function h_tick(offset, spacing, tick_size){
          if(spacing < 2) return;
          var RL = -Math.floor((gridMarginX - rulerWidth) / spacing ) * spacing - offset;
          while(RL < w){
            context.beginPath();
            context.moveTo(gridMarginX + RL, rulerWidth);
            context.lineTo(gridMarginX + RL, rulerWidth - rulerWidth * tick_size);
            context.stroke();
            RL += spacing;
          }
        }
        function v_tick(offset, spacing, tick_size){
          if(spacing < 2) return;

          var RL = -Math.floor((gridMarginY - rulerWidth) / spacing ) * spacing - offset;
          
          while(RL < h){
            context.beginPath();
            context.moveTo(rulerWidth, gridMarginY + RL);
            context.lineTo(rulerWidth - rulerWidth * tick_size, gridMarginY + RL);
            context.stroke();
            RL += spacing;
          }
        }

        function tick(offset, spacing, tick_size){
          v_tick(offset, spacing, tick_size);
          h_tick(offset, spacing, tick_size);
        }

        if(pattern.units === 'INCH'){
          tick(scale / 8, scale/4, .4);
          tick(scale / 4, scale/2, .6);
          tick(scale / 2, scale, .8);
          tick(scale, scale, 1);
          tick(scale*12, scale*12, 1);
          tick(scale*24, scale*24, 1);
          tick(scale*48, scale*48, 1);
        } else if(pattern.units === 'MM'){
          tick(scale, scale, .4);
          tick(scale * 5, scale* 5, .7);
          tick(scale * 10, scale * 10, 1);
        }

        context.strokeStyle = colorConfig.rulerEdge;
        context.beginPath();
        context.moveTo(0, rulerWidth);
        context.lineTo(w, rulerWidth);
        context.stroke();
        context.beginPath();
        context.moveTo(rulerWidth, rulerWidth);
        context.lineTo(rulerWidth, h);
        context.stroke();

        context.fillStyle = colorConfig.bg;
        context.fillRect(0, 0, rulerWidth, rulerWidth);
      }

      // console.log('end render');
      return canvas;
    }


    function checkLineIntersection(line1StartX, line1StartY, line1EndX, line1EndY, line2StartX, line2StartY, line2EndX, line2EndY) {
      // if the lines intersect, the result contains the x and y of the intersection (treating the lines as infinite) and booleans for whether line segment 1 or line segment 2 contain the point
      var denominator, a, b, numerator1, numerator2, result = {
          x: null,
          y: null,
          onLine1: false,
          onLine2: false
      };
      denominator = ((line2EndY - line2StartY) * (line1EndX - line1StartX)) - ((line2EndX - line2StartX) * (line1EndY - line1StartY));
      if (denominator == 0) {
          return result;
      }
      a = line1StartY - line2StartY;
      b = line1StartX - line2StartX;
      numerator1 = ((line2EndX - line2StartX) * a) - ((line2EndY - line2StartY) * b);
      numerator2 = ((line1EndX - line1StartX) * a) - ((line1EndY - line1StartY) * b);
      a = numerator1 / denominator;
      b = numerator2 / denominator;

      // if we cast these lines infinitely in both directions, they intersect here:
      result.x = line1StartX + (a * (line1EndX - line1StartX));
      result.y = line1StartY + (a * (line1EndY - line1StartY));
     
      // if line1 is a segment and line2 is infinite, they intersect if:
      if (a >= 0 && a <= 1) {
        result.onLine1 = true;
      }

      // if line2 is a segment and line1 is infinite, they intersect if:
      if (b >= 0 && b <= 1) {
        result.onLine2 = true;
      }
      // if line1 and line2 are segments, they intersect if both of the above are true
      return result;
    };


    function distance(x1, y1, x2, y2){
      return Math.sqrt( (x1-x2)*(x1-x2) + (y1-y2)*(y1-y2) );
    }

    if(e.data.canvas){
      storedCanvas = e.data.canvas;
    } 
    render(storedCanvas, e.data.pattern, e.data.settings);  

    try{
      postMessage("done");
    } catch(e){
      // we'll hit this on the server it's ok though
    }
  };

  return onmessage;
}


// WEBPACK FOOTER //
// ./src/pattern_utilities/renderWorker.js